(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
(() => {
  if (customElements.get('shipping-benefits-box')) return;

  const memory = new Map();
  const read = (key) => {
    try { return sessionStorage.getItem(key) || memory.get(key); }
    catch (_) { return memory.get(key); }
  };
  const write = (key, value) => {
    memory.set(key, String(value));
    try { sessionStorage.setItem(key, String(value)); } catch (_) {}
  };
  const startKey = 'theme:shipping-benefits:visit:v1';
  let visitStart = Number(read(startKey));
  if (!Number.isFinite(visitStart) || visitStart <= 0 || visitStart > Date.now()) {
    visitStart = Date.now();
    write(startKey, visitStart);
  }

  // Discard old unverified city strings; only cache IBGE-verified names.
  const regionKey = 'theme:visitor-region:ibge:v1';
  const regionTTL = 30 * 60 * 1000;
  const states = new Set('AC AL AP AM BA CE DF ES GO MA MT MS MG PA PB PR PE PI RJ RN RS RO RR SC SP SE TO'.split(' '));
  const normalizeCity = (value) => value.normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase('pt-BR')
    .replace(/[^a-z0-9]/g, '');
  const fetchJSON = async (url) => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 5000);
    try {
      const response = await fetch(url, { signal: controller.signal });
      return response.ok ? await response.json() : null;
    } finally { clearTimeout(timeout); }
  };
  let regionRequest;
  const getRegion = () => {
    try {
      const cached = JSON.parse(read(regionKey) || 'null');
      if (cached && typeof cached.value === 'string' && cached.expiresAt > Date.now()
          && cached.expiresAt <= Date.now() + regionTTL) {
        return Promise.resolve(cached.value);
      }
    } catch (_) {}
    if (regionRequest) return regionRequest;
    regionRequest = (async () => {
      const data = await fetchJSON('https://ipwho.is/?lang=pt-BR&fields=success,country_code,city,region_code');
      if (!data || data.success !== true || data.country_code !== 'BR'
          || typeof data.city !== 'string' || !data.city.trim()) return '';
      const uf = String(data.region_code || '').trim().toUpperCase().replace(/^BR-/, '');
      if (!states.has(uf)) return '';
      const cities = await fetchJSON(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios`);
      if (!Array.isArray(cities)) return '';
      const key = normalizeCity(data.city);
      if (!key) return '';
      // Match within the detected UF. Never guess a similarly named city.
      const matches = cities.filter((city) => city && typeof city.nome === 'string'
        && normalizeCity(city.nome) === key);
      if (matches.length !== 1) return '';
      const value = `${matches[0].nome.normalize('NFC')}-${uf}`;
      write(regionKey, JSON.stringify({ value, expiresAt: Date.now() + regionTTL }));
      return value;
    })()
      .catch(() => '')
      .finally(() => { regionRequest = null; });
    return regionRequest;
  };

  class ShippingBenefitsBox extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected) return;
        clearInterval(this.timer);
        this.deadline = 0;
        this.updateTime();
        if (this.querySelector('[data-shipping-time]')) {
          this.timer = setInterval(() => this.updateTime(), 1000);
        }
        if (this.querySelector('[data-shipping-region]')) {
          getRegion().then((value) => {
            if (!this.isConnected || !value) return;
            this.querySelectorAll('[data-shipping-region]').forEach((node) => {
              node.textContent = value;
            });
          });
        }
      });
    }

    disconnectedCallback() { clearInterval(this.timer); }

    updateTime() {
      const nodes = this.querySelectorAll('[data-shipping-time]');
      if (!nodes.length) return;
      const now = Date.now();
      if (now >= this.deadline) {
        if (this.dataset.timeMode === 'end_of_day') {
          const end = new Date(now);
          end.setHours(24, 0, 0, 0);
          this.deadline = end.getTime();
        } else {
          const hours = Math.min(24, Math.max(1, Number(this.dataset.timeHours) || 2));
          const duration = hours * 3600000;
          // Keep the same cycle across refreshes and catch up after an idle tab.
          const cycles = Math.floor(Math.max(0, now - visitStart) / duration);
          this.deadline = visitStart + (cycles + 1) * duration;
        }
      }
      const displayDate = new Date(this.deadline - (this.dataset.timeMode === 'end_of_day' ? 1 : 0));
      const pad = (n) => String(n).padStart(2, '0');
      let label = `${pad(displayDate.getHours())}h${pad(displayDate.getMinutes())}`;
      if (displayDate.toDateString() !== new Date().toDateString()) {
        label += ` de ${pad(displayDate.getDate())}/${pad(displayDate.getMonth() + 1)}`;
      }
      nodes.forEach((node) => { node.textContent = label; });
      this.querySelectorAll('[data-sb-pending]').forEach((node) => {
        node.removeAttribute('data-sb-pending');
      });
    }
  }
  customElements.define('shipping-benefits-box', ShippingBenefitsBox);
})();

  } catch(e) { console.error(e); }
})();
})();
